var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconTravel128(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 129,
    viewBox: "0 0 128 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Size=128, Dark Mode=No",
    clipPath: "url(#clip0_2589_10539)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Travel"
  }, /*#__PURE__*/React.createElement("path", {
    id: "LineHorz-Copy-4",
    d: "M54 106.503L54 114.503",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "LineHorz-Copy-5",
    d: "M74 106.503V114.503",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle",
    d: "M74 22.5029V17.5029C74 15.8461 72.6569 14.5029 71 14.5029H57C55.3431 14.5029 54 15.8461 54 17.5029L54 22.5029",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.4238 22.5029H85.5758C89.6759 22.5029 92.9998 26.0425 92.9998 30.4088V98.597C92.9998 102.963 89.6759 106.503 85.5758 106.503H42.4238C38.3236 106.503 34.9998 102.963 34.9998 98.597V30.4088C34.9998 26.0425 38.3236 22.5029 42.4238 22.5029Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.9998 90.5029H92.9998V97.9696C92.9998 102.682 89.6759 106.503 85.5758 106.503H42.4238C38.3236 106.503 34.9998 102.682 34.9998 97.9696V90.5029Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "LineHorz-Copy-2",
    d: "M54 36.5029V76.5029",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "LineHorz-Copy-3",
    d: "M74 36.5029V76.5029",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2589_10539"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    fill: "white",
    transform: "translate(0 0.50293)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconTravel128);
export default __webpack_public_path__ + "static/media/pictogramBeaconTravel128.9faceda0a6d73284bdfc2fcc06b8a75d.svg";
export { ForwardRef as ReactComponent };